import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import BrowserSpecific from 'Global/Shared/Components/browser-specific/browser-specific';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';

const log = debug('InspirationCatalogs');
const debounce = new Debounce().debounce;

class InspirationCatalogs extends BaseComponent {
	constructor(element) {
		super(element);

		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);
		
		this.initialize();
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
	}

	/**
	 * @returns {Object} catalogs
	 */
	 async getCatalogs() {
		try {
			return [];
		} catch (error) {
			log('getProduts() - ERROR', error);
		}
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		if (this.getSettings() === null) return;

		this.initDomCache();
		this.eventListeners();

		if (BrowserSpecific.isIE11()) {
			this.setup();
			return;
		}

		if (this.isInView() === false) return;
		this.setup();
	}

	isInView() {
		if (Sitecore.isEdit()) return true;

		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0 || elementRect.bottom > 0) && elementRect.top < window.innerHeight) {
			return true;
		};

		return false;
	}

	ready() {
		// override this method and call local methods
	}

	scrollHandler() {
		if (this.element.classList.contains('is-in-view')) return;
		if (this.isInView() === false) return;
		this.setup();
	}

	async setup() {
		this.catalogs = await this.getCatalogs();
		if (this.catalogs.length === 0) return;

		this.element.classList.add('has-catalogs');

		if (this.isInView() === false && BrowserSpecific.isIE11() === false) return;
		if (this.element.classList.contains('is-in-view')) return;
		this.element.classList.add('is-in-view');

		this.ready();
	}
}

export default InspirationCatalogs;
